module.exports = __webpack_public_path__ + "aa83987c7ec0402ab72fd7a3fb3177b4.fbx";